import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import VonalkodAdatlapEditService from 'app/admin/vonalkodadatlap/service/VonalkodAdatlapEditService';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormGroupFields from 'modules/ui/editform/subForm/EditFormGroupFields';
import ExamImageField from 'app/admin/examImage/ExamImageField';
import nBossConnection from 'modules/base/service/nBossConnection';

const config = {
	key: 'vonalkodAdatlapEditForm',
	text: 'Vonalkod Adatlap',
	textKey: 'vonalkodadatlap',
	service: VonalkodAdatlapEditService,
	icon: 'person',
	fields: [
		{
			key: `vonalkod`,
			component: EditFormGroupFields,
			className: 'w-full flex flex-col sm:flex-row',
			fields: [
				{
					key: 'vizsgaVonalkod',
					text: 'Vizsga vonalkód',
					textKey: 'vizsgaVonalkod',
					component: EditFormTextField,
					type: 'number',
					required: true,
					className: 'sm:mr-6'
				},
				{
					key: 'vonalkod',
					text: 'Vizsgazó vonalkód',
					textKey: 'vonalkod',
					component: EditFormTextField,
					type: 'number',
					required: true,
					className: 'sm:mr-6'
				}
			]
		},
		{
			key: 'adatlapPath',
			text: 'Adatlap',
			textKey: 'adatlapPath',
			component: ExamImageField,
			imageUrl: `${nBossConnection.baseUrl}fmBrowserTableControl/getFileByPath?path=`,
			readOnly: true
		}
	]
};

function VonalkodAdatlapEditForm() {
	return <EditFormPage config={config} />;
}

export default VonalkodAdatlapEditForm;
